import React from "react";
import { Box, Typography } from "@mui/material";
import Faq from "../../intro/faq";

function FaqPage() {
    return (
        <Box>
            <Typography variant="h5">Faq</Typography>
            <Faq />
        </Box>
    );
}

export default FaqPage;
